import type { InjectionKey } from 'vue'
export const dropdownContextKey: InjectionKey<{ close: () => void }> = Symbol('dropdown')
